import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { COMPANY, SERVICES, CITIES } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-brand-navy text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 md:py-20 grid gap-12 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <span className="grid place-items-center w-10 h-10 rounded-lg bg-brand-gold text-brand-navy font-display font-bold text-xl">
              S
            </span>
            <span className="font-display font-semibold text-sm tracking-tight leading-tight">
              SERRURIER
              <span className="block text-[10px] tracking-[0.28em] text-brand-gold">
                LAGNY-SUR-MARNE
              </span>
            </span>
          </div>
          <p className="mt-6 text-sm text-white/60 leading-relaxed max-w-xs">
            Serrurier de proximité à Lagny-sur-Marne depuis {COMPANY.since}.
            Dépannage, ouverture de porte et sécurisation 24h/24.
          </p>
          <a
            href={`tel:${COMPANY.phoneTel}`}
            className="mt-6 inline-flex items-center gap-2 font-display font-semibold text-lg hover:text-brand-gold transition-colors duration-300"
          >
            <Phone className="w-4 h-4" /> {COMPANY.phoneDisplay}
          </a>
        </div>

        <div>
          <h4 className="text-[11px] uppercase tracking-[0.18em] text-brand-gold mb-5 font-semibold">
            Services
          </h4>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="text-sm text-white/70 hover:text-white transition-colors duration-300">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] uppercase tracking-[0.18em] text-brand-gold mb-5 font-semibold">
            Zones d&apos;intervention
          </h4>
          <ul className="space-y-3">
            {CITIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/zone/${c.slug}`} className="text-sm text-white/70 hover:text-white transition-colors duration-300">
                  Serrurier {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] uppercase tracking-[0.18em] text-brand-gold mb-5 font-semibold">
            Adresse
          </h4>
          <p className="flex items-start gap-2 text-sm text-white/70">
            <MapPin className="w-4 h-4 mt-0.5 text-brand-gold shrink-0" />
            {COMPANY.address}
          </p>
          <p className="mt-4 text-sm text-white/70">Ouvert 24h/24 · 7j/7</p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>
            © {new Date().getFullYear()} {COMPANY.name}. Tous droits réservés.
          </span>
          <span className="uppercase tracking-[0.15em]">
            Lagny · Thorigny · Pomponne · St-Thibault · Montévrain · Chessy
          </span>
        </div>
      </div>
    </footer>
  );
}
